"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
exports.breakpoints = {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
        xs: 0,
        sm: 852,
        md: 1020,
        lg: 1220,
        xl: 1220,
    },
};
